import moment from "moment";

const { Input, Switch, Button } = require("antd");
const { useState } = require("react");

export const ExpandedRowRender = ({
  record,
  subscriptions,
  onSubscriptionUpdate,
}) => {
  const companyId = record.companyID;
  const subscription = subscriptions[companyId] || {};

  const [localSubscription, setLocalSubscription] = useState({
    inventoryPage:
      subscription.inventoryPage === "1" || subscription.inventoryPage === 1,
    inventoryPageRegistrationDate:
      subscription.inventoryPageRegistrationDate || "",
    inventoryPageExpirationDate: subscription.inventoryPageExpirationDate || "",
  });

  const handleSwitchChange = (checked) => {
    const updatedSubscription = {
      ...localSubscription,
      inventoryPage: checked,
      inventoryPageRegistrationDate: checked
        ? localSubscription.inventoryPageRegistrationDate
        : "",
      inventoryPageExpirationDate: checked
        ? localSubscription.inventoryPageExpirationDate
        : "",
    };

    setLocalSubscription(updatedSubscription);
  };

  const handleDateChange = (field, value) => {
    const updatedSubscription = {
      ...localSubscription,
      [field]: value,
    };

    setLocalSubscription(updatedSubscription);
  };

  const handleSave = () => {
    onSubscriptionUpdate(companyId, {
      inventoryPage: localSubscription.inventoryPage ? "1" : null,
      inventoryPageRegistrationDate:
        localSubscription.inventoryPageRegistrationDate,
      inventoryPageExpirationDate:
        localSubscription.inventoryPageExpirationDate,
    });
  };

  return (
    <div style={{ padding: "16px", backgroundColor: "#f8f9fa" }}>
      <h5 style={{ marginBottom: "16px" }}>Subscriptions</h5>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "#e9ecef" }}>
            <th
              style={{
                padding: "12px",
                border: "1px solid #dee2e6",
                textAlign: "left",
                fontWeight: "bold",
              }}
            >
              Page Name
            </th>
            <th
              style={{
                padding: "12px",
                border: "1px solid #dee2e6",
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              Status
            </th>
            <th
              style={{
                padding: "12px",
                border: "1px solid #dee2e6",
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              Registration Date
            </th>
            <th
              style={{
                padding: "12px",
                border: "1px solid #dee2e6",
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              Expiration Date
            </th>
            <th
              style={{
                padding: "12px",
                border: "1px solid #dee2e6",
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              style={{
                padding: "12px",
                border: "1px solid #dee2e6",
                fontWeight: "500",
              }}
            >
              Inventory Page
            </td>
            <td
              style={{
                padding: "12px",
                border: "1px solid #dee2e6",
                textAlign: "center",
              }}
            >
              <Switch
                checked={localSubscription.inventoryPage}
                onChange={handleSwitchChange}
              />
            </td>
            <td
              style={{
                padding: "12px",
                border: "1px solid #dee2e6",
                textAlign: "center",
              }}
            >
              <Input
                type="date"
                value={
                  localSubscription.inventoryPageRegistrationDate
                    ? moment(
                        localSubscription.inventoryPageRegistrationDate,
                        "MM-DD-YYYY"
                      ).format("YYYY-MM-DD")
                    : ""
                }
                onChange={(e) => {
                  const formattedDate = moment(
                    e.target.value,
                    "YYYY-MM-DD"
                  ).format("MM-DD-YYYY");
                  handleDateChange(
                    "inventoryPageRegistrationDate",
                    formattedDate
                  );
                }}
                style={{ width: "150px" }}
                disabled={!localSubscription.inventoryPage}
              />
            </td>
            <td
              style={{
                padding: "12px",
                border: "1px solid #dee2e6",
                textAlign: "center",
              }}
            >
              <Input
                type="date"
                value={
                  localSubscription.inventoryPageExpirationDate
                    ? moment(
                        localSubscription.inventoryPageExpirationDate,
                        "MM-DD-YYYY"
                      ).format("YYYY-MM-DD")
                    : ""
                }
                onChange={(e) => {
                  const formattedDate = moment(
                    e.target.value,
                    "YYYY-MM-DD"
                  ).format("MM-DD-YYYY");
                  handleDateChange(
                    "inventoryPageExpirationDate",
                    formattedDate
                  );
                }}
                style={{ width: "150px" }}
                disabled={!localSubscription.inventoryPage}
              />
            </td>
            <td
              style={{
                padding: "12px",
                border: "1px solid #dee2e6",
                textAlign: "center",
              }}
            >
              <Button type="primary" onClick={handleSave}>
                Save
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
